export const CREATE_APPLICATION_SESSION = 'createApplicationSession'
export const READ_APPLICATION_SESSION = 'getApplicationSession'
export const UPDATE_APPLICATION_SESSION = 'updateApplicationSession'
